var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.type)+", млн $")])]),_c('BudgetDatePicker',{attrs:{"type":_vm.paramType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }